import React from 'react';
import Layout from '../../components/UI/Layout/Layout';
import List from '../../components/Entity/Messages/List/List';

const MessagesPage = () => {
  return <Layout title={'sms'} fullwidth={0}>
       <List></List>
   </Layout>;
}

export default MessagesPage;
